let phone = ''
let clear_phone = phone.replace(/\D/g, "")
let mail = ''

export default {
  phone: phone,
  clear_phone: clear_phone,
  phone_href: 'tel:'+ clear_phone,
  mail,
  mail_href: 'mailto:'+mail,
}

export const phoneMask = (val) => {
  return val
    .replace(/\D/g, '')
    .replace(/^(\d)/, '($1')
    .replace(/^(\(\d{3})(\d)/, '$1) $2')
    .replace(/(\d{3})(\d{1,4})/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')
}

export const unlinkVueVariable = (data) => {
  return JSON.parse(JSON.stringify(data))
}
